var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV5Spot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 150,
    height: 150,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 28.71 18.03",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-19.92 -24.33)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 5.98,
    y: 5.6,
    width: 55.92,
    height: 55.92
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.33,24.33a15.91,15.91,0,0,1,14.16,8.49,1,1,0,0,1,0,1A15.74,15.74,0,0,1,36.2,42.24a16,16,0,0,1-16.12-8.36,1,1,0,0,1,0-1.07,16.11,16.11,0,0,1,12-8.38,7.3,7.3,0,0,1,.94-.09c.45,0,.91,0,1.37,0m0,1.65-.61,0a14.23,14.23,0,0,0-11.82,7,.51.51,0,0,0,0,.64c3.33,5.14,8.06,7.52,14.15,6.85a13.82,13.82,0,0,0,10.53-6.84.54.54,0,0,0,0-.68,14.37,14.37,0,0,0-12.31-7",
    transform: "translate(-19.92 -24.33)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.26,38.46a5.23,5.23,0,0,1-5.09-5.56c0-.58.14-.63.71-.49A2.64,2.64,0,0,0,33,29c-.18-.63-.18-.65.46-.76A5.1,5.1,0,0,1,35.1,38.36c-.28,0-.56.07-.84.1",
    transform: "translate(-19.92 -24.33)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV5Spot);
export default __webpack_public_path__ + "static/media/v5_spot.de2e5e5b15de46c56e0f5a395e14bc8c.svg";
export { ForwardRef as ReactComponent };